import React, { useState } from 'react';
import styles from './Checkbox.module.scss';

export default function Checkbox({ id, name, label, onChange, checked, error }) {
  const handleChange = () => {
    onChange(!checked); // Toggle the checked state
  };

  return (
    <div className={styles.checkboxContainer}>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={handleChange}
        className={styles.checkboxInput}
      />
      <label htmlFor={id} className={styles.checkboxLabel}>
        {label}
      </label>

      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
}
